import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const UnauthorizedPage = () => {
  const { auth, logout } = useAuth();
  
  return (
    <Container className="py-5">
      <Row className="justify-content-center text-center">
        <Col md={8} lg={6}>
          <div className="mb-4">
            <i className="bi bi-shield-lock" style={{ fontSize: '4rem', color: '#dc3545' }}></i>
          </div>
          <h1 className="mb-4">Access Denied</h1>
          <p className="lead mb-4">
            You don't have permission to access this page. This area is restricted to authorized users only.
          </p>
          
          {auth?.token ? (
            <div>
              <p>
                You are currently logged in as <strong>{auth.user?.phone}</strong> with role <strong>{auth.user?.role || 'UNKNOWN'}</strong>.
              </p>
              <div className="d-flex justify-content-center gap-3 mt-4">
                <Button as={Link} to="/" variant="primary">
                  Go Home
                </Button>
                <Button onClick={logout} variant="outline-secondary">
                  Logout
                </Button>
              </div>
            </div>
          ) : (
            <div className="d-flex justify-content-center gap-3 mt-4">
              <Button as={Link} to="/login" variant="primary">
                Login
              </Button>
              <Button as={Link} to="/" variant="outline-secondary">
                Go Home
              </Button>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default UnauthorizedPage;
